
/* styles */
require("!!vue-loader/node_modules/vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-fd19de7a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LoadingFullPage.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LoadingFullPage.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-fd19de7a\"}!../../../node_modules/vue-loader/lib/template-compiler/preprocessor?raw&engine=pug!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LoadingFullPage.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/mnt/jenkins-workspace/workspace/bk-frontend-prod/frontend/client/components/loading/LoadingFullPage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LoadingFullPage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fd19de7a", Component.options)
  } else {
    hotAPI.reload("data-v-fd19de7a", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/components/loading/LoadingFullPage.vue
// module id = 1280
// module chunks = 0